import { render, staticRenderFns } from "./ElPromoV2.vue?vue&type=template&id=7b21296a"
import script from "./ElPromoV2.vue?vue&type=script&lang=js"
export * from "./ElPromoV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports